(function () {
  var STORAGE_PREFIX = 'minaki_soft_stock_';
  var DEFAULT_DELAY_MS = 10000;
  var DEFAULT_STOCK_MIN = 2;
  var DEFAULT_STOCK_MAX = 7;

  function parseBound(value, fallback) {
    var number = parseInt(value, 10);
    return isNaN(number) ? fallback : number;
  }

  function randomStockCount(stockMin, stockMax) {
    var low = Math.min(stockMin, stockMax);
    var high = Math.max(stockMin, stockMax);
    return low + Math.floor(Math.random() * (high - low + 1));
  }

  function sessionStockCount(productId, stockMin, stockMax) {
    var storageKey = STORAGE_PREFIX + productId;
    try {
      var savedCount = sessionStorage.getItem(storageKey);
      if (savedCount) {
        var parsedCount = parseInt(savedCount, 10);
        if (!isNaN(parsedCount) && parsedCount >= stockMin && parsedCount <= stockMax) {
          return parsedCount;
        }
      }
      var nextCount = randomStockCount(stockMin, stockMax);
      sessionStorage.setItem(storageKey, String(nextCount));
      return nextCount;
    } catch (error) {
      return randomStockCount(stockMin, stockMax);
    }
  }

  function revealSoftScarcity(root) {
    var countNode = root.querySelector('[data-minaki-soft-scarcity-count]');
    if (!countNode) return;

    var productId = root.getAttribute('data-product-id') || '0';
    var stockMin = parseBound(root.getAttribute('data-stock-min'), DEFAULT_STOCK_MIN);
    var stockMax = parseBound(root.getAttribute('data-stock-max'), DEFAULT_STOCK_MAX);
    var stockCount = sessionStockCount(productId, stockMin, stockMax);

    countNode.textContent = String(stockCount);
    root.hidden = false;
    requestAnimationFrame(function () {
      root.classList.add('is--visible');
    });
  }

  function initSoftScarcity(root) {
    if (!root || root.getAttribute('data-soft-scarcity-ready') === '1') return;
    root.setAttribute('data-soft-scarcity-ready', '1');

    var delayMs = parseBound(root.getAttribute('data-delay-ms'), DEFAULT_DELAY_MS);
    window.setTimeout(function () {
      revealSoftScarcity(root);
    }, Math.max(0, delayMs));
  }

  function boot() {
    document.querySelectorAll('[data-minaki-soft-scarcity]').forEach(initSoftScarcity);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', boot);
})();
